<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                            <template v-else>
                                Siswa
                            </template>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/view', params: {id: student.userID} }">
                                {{ student.user.name }}
                            </router-link>
                            <template v-else>
                                {{ student.user.name }}
                            </template>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Rekomendasi Prodi
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row justify-content-end align-items-center mb-4">
            <div class="col">
                <h3 class="mb-0">
                    Rekomendasi Prodi {{ courseCategory.name }}
                </h3>
            </div>
            <div class="col-auto ml-auto">
                <form class="form-inline" v-on:submit.prevent="paginate(1)">
                    <div class="row align-items-center">
                        <div class="col-auto pr-1">
                            <label class="text-muted">Cari</label>
                        </div>
                        <div class="col px-1">
                            <input v-model="form.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-auto pl-1">
                            <button type="submit" class="btn btn-danger btn-sm px-3">
                                Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div id="table-primary" class="table-responsive px-2">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col">
                                    Program Studi
                                </th>
                                <th scope="col">
                                    Nama PTN
                                </th>
                                <th scope="col">
                                    NBA
                                </th>
                                <th scope="col">
                                    Akreditasi
                                </th>
                            </tr>
                        </thead>
                        <tbody class="font-weight-medium">
                            <tr class="shadow-sm" v-for="universityCourse in universityCourses">
                                <td class="text-center py-4">
                                    <router-link v-bind:to="{ name: 'program-study/view', params: {type: universityCourse.course.department.courseCategoryID, id: universityCourse.courseID} }" class="text-loading">{{ universityCourse.name }}</router-link>
                                </td>
                                <td class="py-4">
                                    <span class="text-loading">{{ universityCourse.university.name }}</span>
                                </td>
                                <td class="py-4">
                                    <span v-if="universityCourse.nba" class="text-loading">{{ universityCourse.nba }}%</span>
                                    <i class="fa fa-minus" v-else></i>
                                </td>
                                <td class="py-4">
                                    <span class="text-loading" v-if="universityCourse.accreditation">{{ universityCourse.accreditation }}</span>
                                    <i class="fa fa-minus" v-else></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import { mapState } from 'vuex';

    export default {
        name: "StudentTryoutRecommendationIndex",
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    keyword: ''
                },
                student: {user: {}},
                courseCategory: {},
                universityCourses: [],
                pageCount: 10,
                page: 1
            };
        },
        methods: {
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/student/course-recommendation', {params: Object.assign({}, this.form, {page: page, studentID: this.student.userID, courseCategoryID: this.courseCategory.id})}).then(response => {
                    this.universityCourses = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager));
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/student/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/course-category')
            ]).then(this.axios.spread(function (responseStudent, responseCourseCategory) {
                this.student = responseStudent.data.data;
                this.courseCategory = responseCourseCategory.data.data.find(courseCategory => courseCategory.id === parseInt(this.$route.params.type));
                if (!this.courseCategory) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Program Study not found'}});
                }
                this.paginate(1, false);

                document.title = 'Rekomendasi Prodi ' + this.courseCategory.name + ': ' + this.student.user.name + ' - ' + process.env.APP_NAME;
            }.bind(this)));
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/student/recommendation/Index.vue